import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MtnaExtendedFabModule } from '@mtna/core-angular';

import { OnLastStepPipe } from './on-last-step.pipe';
import { RdsStepperComponent } from './stepper.component';

@NgModule({
  imports: [CommonModule, FlexModule, MatButtonModule, MatIconModule, MtnaExtendedFabModule, ObserversModule],
  declarations: [RdsStepperComponent, OnLastStepPipe],
  exports: [RdsStepperComponent, MatStepperModule],
})
export class RdsStepperModule {}

export * from './stepper.component';
